import AuthContext from "context/AuthContext";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {useState, useContext, useRef} from "react";
import {useTranslation} from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";
import TabDownload from "./import/TabDownload";
import TabSelectFile from "./import/TabSelectFile";
import TabVerifyData from "./import/TabVerifyData";
import TabConfirmImport from "./import/TabConfirmImport";
import TabResult from "./import/TabResult";

import navs from "./navs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// TODO descargar excel con el resultado de las lineas con warnings

const stepTabsStatus = {
    //Status disabled tabs
    download: false,
    select: false,
    validation: true,
    confirmation: true,
    result: true,
};

const dataVerified = {
    news: {actives: 0, devices: 0},
    updated: {actives: 0, devices: 0},
    counter: {actives: 0, devices: 0},
    errors: 0,
    warnings: 0,
    routes: 0,
    groups: 0,
    islands: 0,
};

function ViewAssetImport() {
    const {user} = useContext(AuthContext);
    const [t] = useTranslation("routes");
    const [tF] = useTranslation("forms");
    document.title = t("labels.import");
    const bread = [
        {
            name: t("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        {
            name: "Importaciones",
            url: "/asset-management/imports/",
            current: false,
        },
        {
            name: t("labels.import"),
            current: true,
        },
    ];

    const [keyTab, setKeyTab] = useState("download");
    const [statusTabs, setStatusTabs] = useState({...stepTabsStatus});
    const warnings = useRef([]);
    const [warningsShow, setWarningsShow] = useState([]);
    const [dataVerify, setDataVerify] = useState({...dataVerified});
    const [roomID, setRoomID] = useState("");

    const handleBackSelectFile = () => {
        let tabs = {...stepTabsStatus};
        tabs.validation = true;
        tabs.confirmation = true;
        tabs.result = true;
        setStatusTabs(tabs);
        setKeyTab("select");
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="col-12 preview-canvas offcanvas-header mt-1">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="file-import" />
                </div>

                <div className="preview-title ps-4">
                    <h5>{tF("inventory.title")}</h5>
                </div>
            </div>
            <Tabs
                activeKey={keyTab}
                id="import-devices-form"
                onSelect={(k) => setKeyTab(k)}
                className="mb-3"
                justify>
                <Tab eventKey="download" title={tF("labels.download")}>
                    <TabDownload user={user} setKeyTab={setKeyTab} />
                </Tab>
                <Tab eventKey="select" title={tF("labels.select-file")}>
                    <TabSelectFile user={user} />
                </Tab>
                <Tab
                    eventKey="validation"
                    title={tF("labels.validation-data")}
                    disabled={statusTabs.validation}>
                    <TabVerifyData
                        statusTabs={statusTabs}
                        setStatusTabs={setStatusTabs}
                        setKeyTab={setKeyTab}
                        setDataVerify={setDataVerify}
                        setRoomID={setRoomID}
                        roomID={roomID}
                        setWarnings={setWarningsShow}
                        warnings={warnings}
                        handleBackSelectFile={handleBackSelectFile}
                    />
                </Tab>
                <Tab
                    eventKey="confirmation"
                    title={tF("labels.confirmation")}
                    disabled={statusTabs.confirmation}>
                    <TabConfirmImport
                        statusTabs={statusTabs}
                        warnings={warningsShow}
                        dataVerify={dataVerify}
                        handleBackSelectFile={handleBackSelectFile}
                        setStatusTabs={setStatusTabs}
                        setKeyTab={setKeyTab}
                        roomID={roomID}
                    />
                </Tab>
                <Tab
                    eventKey="result"
                    title={tF("labels.result")}
                    disabled={statusTabs.result}>
                    <TabResult warns={warnings} />
                </Tab>
            </Tabs>
        </>
    );
}

export default ViewAssetImport;
